namespace Gamification.Gamification {
    export namespace TipologieCaricamentiService {
        export const baseUrl = 'Gamification/TipologieCaricamenti';

        export declare function Create(request: Serenity.SaveRequest<TipologieCaricamentiRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<TipologieCaricamentiRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TipologieCaricamentiRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TipologieCaricamentiRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/TipologieCaricamenti/Create",
            Update = "Gamification/TipologieCaricamenti/Update",
            Delete = "Gamification/TipologieCaricamenti/Delete",
            Retrieve = "Gamification/TipologieCaricamenti/Retrieve",
            List = "Gamification/TipologieCaricamenti/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>TipologieCaricamentiService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
